<template>
	<v-hover v-slot="{ hover }">
		<router-link
			:to="{
				name: 'PrductShow',
				params: { id: product.id },
			}"
			style="text-decoration: none; color: inherit;"
		>
			<v-card
				:class="[
					'product-container',
					{ scale: hover },
					{ 'product-container-active': active },
				]"
				:elevation="
					(hover || active) && $vuetify.breakpoint.mdAndUp ? 6 : 1
				"
			>
				<v-card-text class="pa-0">
					<div class="product-top-container">
						<span>
							{{ product.code }}
						</span>
					</div>

					<div
						:class="[
							'main-image-container',
							{ 'no-image': mainImage == null },
						]"
					>
						<img :src="mainImage" alt="" v-if="mainImage" />
					</div>

					<v-divider></v-divider>

					<div class="d-flex flex-column pl-4 pr-4 product-details">
						<h5 class="font-weight-thin">
							{{ product.category.name }}
						</h5>
						<h3 class="black--text">
							{{ product.name }}
						</h3>
					</div>
				</v-card-text>
				<div class="active" v-if="active">
					<span>
						Producto actual seleccionado
					</span>
				</div>
			</v-card>
		</router-link>
	</v-hover>
</template>

<script>
export default {
	props: {
		product: [Object],

		active: [Boolean],
	},

	data() {
		return {};
	},

	created() {},

	methods: {},

	computed: {
		mainImage() {
			if (this.product.images) {
				if (this.product.images.length > 0) {
					return this.product.images[0];
				}
			}

			return null;
		},
	},
};
</script>

<style lang="css" scoped>
.product-container {
	width: 260px;
	height: 325px;
	margin: 0;
	padding: 0;
	cursor: pointer;
	transition: all 0.2s linear;
}

.main-image-container {
	height: 250px;
	max-width: 100%;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
}

.main-image-container img {
	max-height: 90%;
}

.product-details {
	padding: 10px;
	height: 90px;
	/*background-color: red;*/
}

.price-container {
	min-height: 40px;
	max-height: 60px;
}

.product-name {
	font-size: 13px;
	margin-top: 3px;
	width: 100%;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	color: #000;
}

.product-top-container {
	top: 0;
	color: #000;
	width: 100%;
	display: flex;
	position: absolute;
	align-items: center;
	padding: 10px 10px 0 10px;
	justify-content: space-between;
}

.active {
	content: "";
	top: 0;
	left: 0;
	z-index: 10;
	width: 100%;
	height: 100%;
	display: flex;
	position: absolute;
	justify-content: center;
	align-items: center;
	background: linear-gradient(
		0deg,
		rgba(0, 0, 0, 0.7) 0%,
		rgba(0, 0, 0, 0.1) 100%
	);
}

.active span {
	color: #fff;
}
</style>
